import { Input } from "antd";
import { styled } from "styled-components";

export const InputDateStyle = styled(Input)``;


